enum WebAuthnSupportMessage {
  FULL_SUPPORT = 'webauthn full support',
  PARTIAL_SUPPORT = 'webauthn partial support',
  NO_SUPPORT = 'webauthn no support'
}

export default WebAuthnSupportMessage
